/*
 * Copyright 2015-present Palantir Technologies, Inc. All rights reserved.
 */

// tslint:disable:object-literal-sort-keys
export const IconClasses = {
    BLANK: "pt-icon-blank" as "pt-icon-blank",
    STYLE: "pt-icon-style" as "pt-icon-style",
    ALIGN_LEFT: "pt-icon-align-left" as "pt-icon-align-left",
    ALIGN_CENTER: "pt-icon-align-center" as "pt-icon-align-center",
    ALIGN_RIGHT: "pt-icon-align-right" as "pt-icon-align-right",
    ALIGN_JUSTIFY: "pt-icon-align-justify" as "pt-icon-align-justify",
    BOLD: "pt-icon-bold" as "pt-icon-bold",
    ITALIC: "pt-icon-italic" as "pt-icon-italic",
    UNDERLINE: "pt-icon-underline" as "pt-icon-underline",
    SEARCH_AROUND: "pt-icon-search-around" as "pt-icon-search-around",
    GRAPH_REMOVE: "pt-icon-graph-remove" as "pt-icon-graph-remove",
    GROUP_OBJECTS: "pt-icon-group-objects" as "pt-icon-group-objects",
    MERGE_LINKS: "pt-icon-merge-links" as "pt-icon-merge-links",
    LAYOUT: "pt-icon-layout" as "pt-icon-layout",
    LAYOUT_AUTO: "pt-icon-layout-auto" as "pt-icon-layout-auto",
    LAYOUT_CIRCLE: "pt-icon-layout-circle" as "pt-icon-layout-circle",
    LAYOUT_HIERARCHY: "pt-icon-layout-hierarchy" as "pt-icon-layout-hierarchy",
    LAYOUT_GRID: "pt-icon-layout-grid" as "pt-icon-layout-grid",
    LAYOUT_GROUP_BY: "pt-icon-layout-group-by" as "pt-icon-layout-group-by",
    LAYOUT_SKEW_GRID: "pt-icon-layout-skew-grid" as "pt-icon-layout-skew-grid",
    GEOSEARCH: "pt-icon-geosearch" as "pt-icon-geosearch",
    HEATMAP: "pt-icon-heatmap" as "pt-icon-heatmap",
    DRIVE_TIME: "pt-icon-drive-time" as "pt-icon-drive-time",
    SELECT: "pt-icon-select" as "pt-icon-select",
    PREDICTIVE_ANALYSIS: "pt-icon-predictive-analysis" as "pt-icon-predictive-analysis",
    LAYERS: "pt-icon-layers" as "pt-icon-layers",
    LOCATE: "pt-icon-locate" as "pt-icon-locate",
    BOOKMARK: "pt-icon-bookmark" as "pt-icon-bookmark",
    CITATION: "pt-icon-citation" as "pt-icon-citation",
    TAG: "pt-icon-tag" as "pt-icon-tag",
    CLIPBOARD: "pt-icon-clipboard" as "pt-icon-clipboard",
    SELECTION: "pt-icon-selection" as "pt-icon-selection",
    TIMELINE_EVENTS: "pt-icon-timeline-events" as "pt-icon-timeline-events",
    TIMELINE_LINE_CHART: "pt-icon-timeline-line-chart" as "pt-icon-timeline-line-chart",
    TIMELINE_BAR_CHART: "pt-icon-timeline-bar-chart" as "pt-icon-timeline-bar-chart",
    APPLICATIONS: "pt-icon-applications" as "pt-icon-applications",
    PROJECTS: "pt-icon-projects" as "pt-icon-projects",
    CHANGES: "pt-icon-changes" as "pt-icon-changes",
    NOTIFICATIONS: "pt-icon-notifications" as "pt-icon-notifications",
    LOCK: "pt-icon-lock" as "pt-icon-lock",
    UNLOCK: "pt-icon-unlock" as "pt-icon-unlock",
    USER: "pt-icon-user" as "pt-icon-user",
    SEARCH_TEMPLATE: "pt-icon-search-template" as "pt-icon-search-template",
    INBOX: "pt-icon-inbox" as "pt-icon-inbox",
    MORE: "pt-icon-more" as "pt-icon-more",
    HELP: "pt-icon-help" as "pt-icon-help",
    CALENDAR: "pt-icon-calendar" as "pt-icon-calendar",
    MEDIA: "pt-icon-media" as "pt-icon-media",
    LINK: "pt-icon-link" as "pt-icon-link",
    SHARE: "pt-icon-share" as "pt-icon-share",
    DOWNLOAD: "pt-icon-download" as "pt-icon-download",
    DOCUMENT: "pt-icon-document" as "pt-icon-document",
    PROPERTIES: "pt-icon-properties" as "pt-icon-properties",
    IMPORT: "pt-icon-import" as "pt-icon-import",
    EXPORT: "pt-icon-export" as "pt-icon-export",
    MINIMIZE: "pt-icon-minimize" as "pt-icon-minimize",
    MAXIMIZE: "pt-icon-maximize" as "pt-icon-maximize",
    TICK: "pt-icon-tick" as "pt-icon-tick",
    CROSS: "pt-icon-cross" as "pt-icon-cross",
    PLUS: "pt-icon-plus" as "pt-icon-plus",
    MINUS: "pt-icon-minus" as "pt-icon-minus",
    ARROW_LEFT: "pt-icon-arrow-left" as "pt-icon-arrow-left",
    ARROW_RIGHT: "pt-icon-arrow-right" as "pt-icon-arrow-right",
    EXCHANGE: "pt-icon-exchange" as "pt-icon-exchange",
    COMPARISON: "pt-icon-comparison" as "pt-icon-comparison",
    LIST: "pt-icon-list" as "pt-icon-list",
    FILTER: "pt-icon-filter" as "pt-icon-filter",
    CONFIRM: "pt-icon-confirm" as "pt-icon-confirm",
    FORK: "pt-icon-fork" as "pt-icon-fork",
    TRASH: "pt-icon-trash" as "pt-icon-trash",
    PERSON: "pt-icon-person" as "pt-icon-person",
    PEOPLE: "pt-icon-people" as "pt-icon-people",
    ADD: "pt-icon-add" as "pt-icon-add",
    REMOVE: "pt-icon-remove" as "pt-icon-remove",
    GEOLOCATION: "pt-icon-geolocation" as "pt-icon-geolocation",
    ZOOM_IN: "pt-icon-zoom-in" as "pt-icon-zoom-in",
    ZOOM_OUT: "pt-icon-zoom-out" as "pt-icon-zoom-out",
    REFRESH: "pt-icon-refresh" as "pt-icon-refresh",
    DELETE: "pt-icon-delete" as "pt-icon-delete",
    COG: "pt-icon-cog" as "pt-icon-cog",
    FLAG: "pt-icon-flag" as "pt-icon-flag",
    PIN: "pt-icon-pin" as "pt-icon-pin",
    WARNING_SIGN: "pt-icon-warning-sign" as "pt-icon-warning-sign",
    ERROR: "pt-icon-error" as "pt-icon-error",
    INFO_SIGN: "pt-icon-info-sign" as "pt-icon-info-sign",
    CREDIT_CARD: "pt-icon-credit-card" as "pt-icon-credit-card",
    EDIT: "pt-icon-edit" as "pt-icon-edit",
    HISTORY: "pt-icon-history" as "pt-icon-history",
    SEARCH: "pt-icon-search" as "pt-icon-search",
    LOG_OUT: "pt-icon-log-out" as "pt-icon-log-out",
    STAR: "pt-icon-star" as "pt-icon-star",
    STAR_EMPTY: "pt-icon-star-empty" as "pt-icon-star-empty",
    SORT_ALPHABETICAL: "pt-icon-sort-alphabetical" as "pt-icon-sort-alphabetical",
    SORT_NUMERICAL: "pt-icon-sort-numerical" as "pt-icon-sort-numerical",
    SORT: "pt-icon-sort" as "pt-icon-sort",
    FOLDER_OPEN: "pt-icon-folder-open" as "pt-icon-folder-open",
    FOLDER_CLOSE: "pt-icon-folder-close" as "pt-icon-folder-close",
    FOLDER_SHARED: "pt-icon-folder-shared" as "pt-icon-folder-shared",
    CARET_UP: "pt-icon-caret-up" as "pt-icon-caret-up",
    CARET_RIGHT: "pt-icon-caret-right" as "pt-icon-caret-right",
    CARET_DOWN: "pt-icon-caret-down" as "pt-icon-caret-down",
    CARET_LEFT: "pt-icon-caret-left" as "pt-icon-caret-left",
    MENU_OPEN: "pt-icon-menu-open" as "pt-icon-menu-open",
    MENU_CLOSED: "pt-icon-menu-closed" as "pt-icon-menu-closed",
    FEED: "pt-icon-feed" as "pt-icon-feed",
    TWO_COLUMNS: "pt-icon-two-columns" as "pt-icon-two-columns",
    ONE_COLUMN: "pt-icon-one-column" as "pt-icon-one-column",
    DOT: "pt-icon-dot" as "pt-icon-dot",
    PROPERTY: "pt-icon-property" as "pt-icon-property",
    TIME: "pt-icon-time" as "pt-icon-time",
    DISABLE: "pt-icon-disable" as "pt-icon-disable",
    UNPIN: "pt-icon-unpin" as "pt-icon-unpin",
    FLOWS: "pt-icon-flows" as "pt-icon-flows",
    NEW_TEXT_BOX: "pt-icon-new-text-box" as "pt-icon-new-text-box",
    NEW_LINK: "pt-icon-new-link" as "pt-icon-new-link",
    NEW_OBJECT: "pt-icon-new-object" as "pt-icon-new-object",
    PATH_SEARCH: "pt-icon-path-search" as "pt-icon-path-search",
    AUTOMATIC_UPDATES: "pt-icon-automatic-updates" as "pt-icon-automatic-updates",
    PAGE_LAYOUT: "pt-icon-page-layout" as "pt-icon-page-layout",
    CODE: "pt-icon-code" as "pt-icon-code",
    MAP: "pt-icon-map" as "pt-icon-map",
    SEARCH_TEXT: "pt-icon-search-text" as "pt-icon-search-text",
    ENVELOPE: "pt-icon-envelope" as "pt-icon-envelope",
    PAPERCLIP: "pt-icon-paperclip" as "pt-icon-paperclip",
    LABEL: "pt-icon-label" as "pt-icon-label",
    GLOBE: "pt-icon-globe" as "pt-icon-globe",
    HOME: "pt-icon-home" as "pt-icon-home",
    TH: "pt-icon-th" as "pt-icon-th",
    TH_LIST: "pt-icon-th-list" as "pt-icon-th-list",
    TH_DERIVED: "pt-icon-th-derived" as "pt-icon-th-derived",
    CIRCLE: "pt-icon-circle" as "pt-icon-circle",
    DRAW: "pt-icon-draw" as "pt-icon-draw",
    INSERT: "pt-icon-insert" as "pt-icon-insert",
    HELPER_MANAGEMENT: "pt-icon-helper-management" as "pt-icon-helper-management",
    SEND_TO: "pt-icon-send-to" as "pt-icon-send-to",
    EYE_OPEN: "pt-icon-eye-open" as "pt-icon-eye-open",
    FOLDER_SHARED_OPEN: "pt-icon-folder-shared-open" as "pt-icon-folder-shared-open",
    SOCIAL_MEDIA: "pt-icon-social-media" as "pt-icon-social-media",
    ARROW_UP: "pt-icon-arrow-up" as "pt-icon-arrow-up",
    ARROW_DOWN: "pt-icon-arrow-down" as "pt-icon-arrow-down",
    ARROWS_HORIZONTAL: "pt-icon-arrows-horizontal" as "pt-icon-arrows-horizontal",
    ARROWS_VERTICAL: "pt-icon-arrows-vertical" as "pt-icon-arrows-vertical",
    RESOLVE: "pt-icon-resolve" as "pt-icon-resolve",
    GRAPH: "pt-icon-graph" as "pt-icon-graph",
    BRIEFCASE: "pt-icon-briefcase" as "pt-icon-briefcase",
    DOLLAR: "pt-icon-dollar" as "pt-icon-dollar",
    NINJA: "pt-icon-ninja" as "pt-icon-ninja",
    DELTA: "pt-icon-delta" as "pt-icon-delta",
    BARCODE: "pt-icon-barcode" as "pt-icon-barcode",
    TORCH: "pt-icon-torch" as "pt-icon-torch",
    WIDGET: "pt-icon-widget" as "pt-icon-widget",
    UNRESOLVE: "pt-icon-unresolve" as "pt-icon-unresolve",
    OFFLINE: "pt-icon-offline" as "pt-icon-offline",
    ZOOM_TO_FIT: "pt-icon-zoom-to-fit" as "pt-icon-zoom-to-fit",
    ADD_TO_ARTIFACT: "pt-icon-add-to-artifact" as "pt-icon-add-to-artifact",
    MAP_MARKER: "pt-icon-map-marker" as "pt-icon-map-marker",
    CHART: "pt-icon-chart" as "pt-icon-chart",
    CONTROL: "pt-icon-control" as "pt-icon-control",
    MULTI_SELECT: "pt-icon-multi-select" as "pt-icon-multi-select",
    DIRECTION_LEFT: "pt-icon-direction-left" as "pt-icon-direction-left",
    DIRECTION_RIGHT: "pt-icon-direction-right" as "pt-icon-direction-right",
    DATABASE: "pt-icon-database" as "pt-icon-database",
    PIE_CHART: "pt-icon-pie-chart" as "pt-icon-pie-chart",
    FULL_CIRCLE: "pt-icon-full-circle" as "pt-icon-full-circle",
    SQUARE: "pt-icon-square" as "pt-icon-square",
    PRINT: "pt-icon-print" as "pt-icon-print",
    PRESENTATION: "pt-icon-presentation" as "pt-icon-presentation",
    UNGROUP_OBJECTS: "pt-icon-ungroup-objects" as "pt-icon-ungroup-objects",
    CHAT: "pt-icon-chat" as "pt-icon-chat",
    COMMENT: "pt-icon-comment" as "pt-icon-comment",
    CIRCLE_ARROW_RIGHT: "pt-icon-circle-arrow-right" as "pt-icon-circle-arrow-right",
    CIRCLE_ARROW_LEFT: "pt-icon-circle-arrow-left" as "pt-icon-circle-arrow-left",
    CIRCLE_ARROW_UP: "pt-icon-circle-arrow-up" as "pt-icon-circle-arrow-up",
    CIRCLE_ARROW_DOWN: "pt-icon-circle-arrow-down" as "pt-icon-circle-arrow-down",
    UPLOAD: "pt-icon-upload" as "pt-icon-upload",
    ASTERISK: "pt-icon-asterisk" as "pt-icon-asterisk",
    CLOUD: "pt-icon-cloud" as "pt-icon-cloud",
    CLOUD_DOWNLOAD: "pt-icon-cloud-download" as "pt-icon-cloud-download",
    CLOUD_UPLOAD: "pt-icon-cloud-upload" as "pt-icon-cloud-upload",
    REPEAT: "pt-icon-repeat" as "pt-icon-repeat",
    MOVE: "pt-icon-move" as "pt-icon-move",
    CHEVRON_LEFT: "pt-icon-chevron-left" as "pt-icon-chevron-left",
    CHEVRON_RIGHT: "pt-icon-chevron-right" as "pt-icon-chevron-right",
    CHEVRON_UP: "pt-icon-chevron-up" as "pt-icon-chevron-up",
    CHEVRON_DOWN: "pt-icon-chevron-down" as "pt-icon-chevron-down",
    RANDOM: "pt-icon-random" as "pt-icon-random",
    FULLSCREEN: "pt-icon-fullscreen" as "pt-icon-fullscreen",
    LOG_IN: "pt-icon-log-in" as "pt-icon-log-in",
    HEART: "pt-icon-heart" as "pt-icon-heart",
    OFFICE: "pt-icon-office" as "pt-icon-office",
    DUPLICATE: "pt-icon-duplicate" as "pt-icon-duplicate",
    BAN_CIRCLE: "pt-icon-ban-circle" as "pt-icon-ban-circle",
    CAMERA: "pt-icon-camera" as "pt-icon-camera",
    MOBILE_VIDEO: "pt-icon-mobile-video" as "pt-icon-mobile-video",
    VIDEO: "pt-icon-video" as "pt-icon-video",
    FILM: "pt-icon-film" as "pt-icon-film",
    SETTINGS: "pt-icon-settings" as "pt-icon-settings",
    VOLUME_OFF: "pt-icon-volume-off" as "pt-icon-volume-off",
    VOLUME_DOWN: "pt-icon-volume-down" as "pt-icon-volume-down",
    VOLUME_UP: "pt-icon-volume-up" as "pt-icon-volume-up",
    MUSIC: "pt-icon-music" as "pt-icon-music",
    STEP_BACKWARD: "pt-icon-step-backward" as "pt-icon-step-backward",
    FAST_BACKWARD: "pt-icon-fast-backward" as "pt-icon-fast-backward",
    PAUSE: "pt-icon-pause" as "pt-icon-pause",
    STOP: "pt-icon-stop" as "pt-icon-stop",
    PLAY: "pt-icon-play" as "pt-icon-play",
    FAST_FORWARD: "pt-icon-fast-forward" as "pt-icon-fast-forward",
    STEP_FORWARD: "pt-icon-step-forward" as "pt-icon-step-forward",
    EJECT: "pt-icon-eject" as "pt-icon-eject",
    RECORD: "pt-icon-record" as "pt-icon-record",
    DESKTOP: "pt-icon-desktop" as "pt-icon-desktop",
    PHONE: "pt-icon-phone" as "pt-icon-phone",
    LIGHTBULB: "pt-icon-lightbulb" as "pt-icon-lightbulb",
    GLASS: "pt-icon-glass" as "pt-icon-glass",
    TINT: "pt-icon-tint" as "pt-icon-tint",
    FLASH: "pt-icon-flash" as "pt-icon-flash",
    FONT: "pt-icon-font" as "pt-icon-font",
    HEADER: "pt-icon-header" as "pt-icon-header",
    SAVED: "pt-icon-saved" as "pt-icon-saved",
    FLOPPY_DISK: "pt-icon-floppy-disk" as "pt-icon-floppy-disk",
    BOOK: "pt-icon-book" as "pt-icon-book",
    HAND_RIGHT: "pt-icon-hand-right" as "pt-icon-hand-right",
    HAND_UP: "pt-icon-hand-up" as "pt-icon-hand-up",
    HAND_DOWN: "pt-icon-hand-down" as "pt-icon-hand-down",
    HAND_LEFT: "pt-icon-hand-left" as "pt-icon-hand-left",
    THUMBS_UP: "pt-icon-thumbs-up" as "pt-icon-thumbs-up",
    THUMBS_DOWN: "pt-icon-thumbs-down" as "pt-icon-thumbs-down",
    BOX: "pt-icon-box" as "pt-icon-box",
    COMPRESSED: "pt-icon-compressed" as "pt-icon-compressed",
    SHOPPING_CART: "pt-icon-shopping-cart" as "pt-icon-shopping-cart",
    SHOP: "pt-icon-shop" as "pt-icon-shop",
    LAYOUT_LINEAR: "pt-icon-layout-linear" as "pt-icon-layout-linear",
    UNDO: "pt-icon-undo" as "pt-icon-undo",
    REDO: "pt-icon-redo" as "pt-icon-redo",
    CODE_BLOCK: "pt-icon-code-block" as "pt-icon-code-block",
    DOUBLE_CARET_VERTICAL: "pt-icon-double-caret-vertical" as "pt-icon-double-caret-vertical",
    DOUBLE_CARET_HORIZONTAL: "pt-icon-double-caret-horizontal" as "pt-icon-double-caret-horizontal",
    SORT_ALPHABETICAL_DESC: "pt-icon-sort-alphabetical-desc" as "pt-icon-sort-alphabetical-desc",
    SORT_NUMERICAL_DESC: "pt-icon-sort-numerical-desc" as "pt-icon-sort-numerical-desc",
    TAKE_ACTION: "pt-icon-take-action" as "pt-icon-take-action",
    CONTRAST: "pt-icon-contrast" as "pt-icon-contrast",
    EYE_OFF: "pt-icon-eye-off" as "pt-icon-eye-off",
    TIMELINE_AREA_CHART: "pt-icon-timeline-area-chart" as "pt-icon-timeline-area-chart",
    DOUGHNUT_CHART: "pt-icon-doughnut-chart" as "pt-icon-doughnut-chart",
    LAYER: "pt-icon-layer" as "pt-icon-layer",
    GRID: "pt-icon-grid" as "pt-icon-grid",
    POLYGON_FILTER: "pt-icon-polygon-filter" as "pt-icon-polygon-filter",
    ADD_TO_FOLDER: "pt-icon-add-to-folder" as "pt-icon-add-to-folder",
    LAYOUT_BALLOON: "pt-icon-layout-balloon" as "pt-icon-layout-balloon",
    LAYOUT_SORTED_CLUSTERS: "pt-icon-layout-sorted-clusters" as "pt-icon-layout-sorted-clusters",
    SORT_ASC: "pt-icon-sort-asc" as "pt-icon-sort-asc",
    SORT_DESC: "pt-icon-sort-desc" as "pt-icon-sort-desc",
    SMALL_CROSS: "pt-icon-small-cross" as "pt-icon-small-cross",
    SMALL_TICK: "pt-icon-small-tick" as "pt-icon-small-tick",
    POWER: "pt-icon-power" as "pt-icon-power",
    COLUMN_LAYOUT: "pt-icon-column-layout" as "pt-icon-column-layout",
    ARROW_TOP_LEFT: "pt-icon-arrow-top-left" as "pt-icon-arrow-top-left",
    ARROW_TOP_RIGHT: "pt-icon-arrow-top-right" as "pt-icon-arrow-top-right",
    ARROW_BOTTOM_RIGHT: "pt-icon-arrow-bottom-right" as "pt-icon-arrow-bottom-right",
    ARROW_BOTTOM_LEFT: "pt-icon-arrow-bottom-left" as "pt-icon-arrow-bottom-left",
    MUGSHOT: "pt-icon-mugshot" as "pt-icon-mugshot",
    HEADSET: "pt-icon-headset" as "pt-icon-headset",
    TEXT_HIGHLIGHT: "pt-icon-text-highlight" as "pt-icon-text-highlight",
    HAND: "pt-icon-hand" as "pt-icon-hand",
    CHEVRON_BACKWARD: "pt-icon-chevron-backward" as "pt-icon-chevron-backward",
    CHEVRON_FORWARD: "pt-icon-chevron-forward" as "pt-icon-chevron-forward",
    ROTATE_DOCUMENT: "pt-icon-rotate-document" as "pt-icon-rotate-document",
    ROTATE_PAGE: "pt-icon-rotate-page" as "pt-icon-rotate-page",
    BADGE: "pt-icon-badge" as "pt-icon-badge",
    GRID_VIEW: "pt-icon-grid-view" as "pt-icon-grid-view",
    FUNCTION: "pt-icon-function" as "pt-icon-function",
    WATERFALL_CHART: "pt-icon-waterfall-chart" as "pt-icon-waterfall-chart",
    STACKED_CHART: "pt-icon-stacked-chart" as "pt-icon-stacked-chart",
    PULSE: "pt-icon-pulse" as "pt-icon-pulse",
    NEW_PERSON: "pt-icon-new-person" as "pt-icon-new-person",
    EXCLUDE_ROW: "pt-icon-exclude-row" as "pt-icon-exclude-row",
    PIVOT_TABLE: "pt-icon-pivot-table" as "pt-icon-pivot-table",
    SEGMENTED_CONTROL: "pt-icon-segmented-control" as "pt-icon-segmented-control",
    HIGHLIGHT: "pt-icon-highlight" as "pt-icon-highlight",
    FILTER_LIST: "pt-icon-filter-list" as "pt-icon-filter-list",
    CUT: "pt-icon-cut" as "pt-icon-cut",
    ANNOTATION: "pt-icon-annotation" as "pt-icon-annotation",
    PIVOT: "pt-icon-pivot" as "pt-icon-pivot",
    RING: "pt-icon-ring" as "pt-icon-ring",
    HEAT_GRID: "pt-icon-heat-grid" as "pt-icon-heat-grid",
    GANTT_CHART: "pt-icon-gantt-chart" as "pt-icon-gantt-chart",
    VARIABLE: "pt-icon-variable" as "pt-icon-variable",
    MANUAL: "pt-icon-manual" as "pt-icon-manual",
    ADD_ROW_TOP: "pt-icon-add-row-top" as "pt-icon-add-row-top",
    ADD_ROW_BOTTOM: "pt-icon-add-row-bottom" as "pt-icon-add-row-bottom",
    ADD_COLUMN_LEFT: "pt-icon-add-column-left" as "pt-icon-add-column-left",
    ADD_COLUMN_RIGHT: "pt-icon-add-column-right" as "pt-icon-add-column-right",
    REMOVE_ROW_TOP: "pt-icon-remove-row-top" as "pt-icon-remove-row-top",
    REMOVE_ROW_BOTTOM: "pt-icon-remove-row-bottom" as "pt-icon-remove-row-bottom",
    REMOVE_COLUMN_LEFT: "pt-icon-remove-column-left" as "pt-icon-remove-column-left",
    REMOVE_COLUMN_RIGHT: "pt-icon-remove-column-right" as "pt-icon-remove-column-right",
    DOUBLE_CHEVRON_LEFT: "pt-icon-double-chevron-left" as "pt-icon-double-chevron-left",
    DOUBLE_CHEVRON_RIGHT: "pt-icon-double-chevron-right" as "pt-icon-double-chevron-right",
    DOUBLE_CHEVRON_UP: "pt-icon-double-chevron-up" as "pt-icon-double-chevron-up",
    DOUBLE_CHEVRON_DOWN: "pt-icon-double-chevron-down" as "pt-icon-double-chevron-down",
    KEY_CONTROL: "pt-icon-key-control" as "pt-icon-key-control",
    KEY_COMMAND: "pt-icon-key-command" as "pt-icon-key-command",
    KEY_SHIFT: "pt-icon-key-shift" as "pt-icon-key-shift",
    KEY_BACKSPACE: "pt-icon-key-backspace" as "pt-icon-key-backspace",
    KEY_DELETE: "pt-icon-key-delete" as "pt-icon-key-delete",
    KEY_ESCAPE: "pt-icon-key-escape" as "pt-icon-key-escape",
    KEY_ENTER: "pt-icon-key-enter" as "pt-icon-key-enter",
    CALCULATOR: "pt-icon-calculator" as "pt-icon-calculator",
    HORIZONTAL_BAR_CHART: "pt-icon-horizontal-bar-chart" as "pt-icon-horizontal-bar-chart",
    SMALL_PLUS: "pt-icon-small-plus" as "pt-icon-small-plus",
    SMALL_MINUS: "pt-icon-small-minus" as "pt-icon-small-minus",
    STEP_CHART: "pt-icon-step-chart" as "pt-icon-step-chart",
    EURO: "pt-icon-euro" as "pt-icon-euro",
    DRAG_HANDLE_VERTICAL: "pt-icon-drag-handle-vertical" as "pt-icon-drag-handle-vertical",
    DRAG_HANDLE_HORIZONTAL: "pt-icon-drag-handle-horizontal" as "pt-icon-drag-handle-horizontal",
    MOBILE_PHONE: "pt-icon-mobile-phone" as "pt-icon-mobile-phone",
    SIM_CARD: "pt-icon-sim-card" as "pt-icon-sim-card",
    TRENDING_UP: "pt-icon-trending-up" as "pt-icon-trending-up",
    TRENDING_DOWN: "pt-icon-trending-down" as "pt-icon-trending-down",
    CURVED_RANGE_CHART: "pt-icon-curved-range-chart" as "pt-icon-curved-range-chart",
    VERTICAL_BAR_CHART_DESC: "pt-icon-vertical-bar-chart-desc" as "pt-icon-vertical-bar-chart-desc",
    HORIZONTAL_BAR_CHART_DESC: "pt-icon-horizontal-bar-chart-desc" as "pt-icon-horizontal-bar-chart-desc",
    DOCUMENT_OPEN: "pt-icon-document-open" as "pt-icon-document-open",
    DOCUMENT_SHARE: "pt-icon-document-share" as "pt-icon-document-share",
    HORIZONTAL_DISTRIBUTION: "pt-icon-horizontal-distribution" as "pt-icon-horizontal-distribution",
    VERTICAL_DISTRIBUTION: "pt-icon-vertical-distribution" as "pt-icon-vertical-distribution",
    ALIGNMENT_LEFT: "pt-icon-alignment-left" as "pt-icon-alignment-left",
    ALIGNMENT_VERTICAL_CENTER: "pt-icon-alignment-vertical-center" as "pt-icon-alignment-vertical-center",
    ALIGNMENT_RIGHT: "pt-icon-alignment-right" as "pt-icon-alignment-right",
    ALIGNMENT_TOP: "pt-icon-alignment-top" as "pt-icon-alignment-top",
    ALIGNMENT_HORIZONTAL_CENTER: "pt-icon-alignment-horizontal-center" as "pt-icon-alignment-horizontal-center",
    ALIGNMENT_BOTTOM: "pt-icon-alignment-bottom" as "pt-icon-alignment-bottom",
    GIT_PULL: "pt-icon-git-pull" as "pt-icon-git-pull",
    GIT_MERGE: "pt-icon-git-merge" as "pt-icon-git-merge",
    GIT_BRANCH: "pt-icon-git-branch" as "pt-icon-git-branch",
    GIT_COMMIT: "pt-icon-git-commit" as "pt-icon-git-commit",
    GIT_PUSH: "pt-icon-git-push" as "pt-icon-git-push",
    BUILD: "pt-icon-build" as "pt-icon-build",
    SYMBOL_CIRCLE: "pt-icon-symbol-circle" as "pt-icon-symbol-circle",
    SYMBOL_SQUARE: "pt-icon-symbol-square" as "pt-icon-symbol-square",
    SYMBOL_DIAMOND: "pt-icon-symbol-diamond" as "pt-icon-symbol-diamond",
    SYMBOL_CROSS: "pt-icon-symbol-cross" as "pt-icon-symbol-cross",
    SYMBOL_TRIANGLE_UP: "pt-icon-symbol-triangle-up" as "pt-icon-symbol-triangle-up",
    SYMBOL_TRIANGLE_DOWN: "pt-icon-symbol-triangle-down" as "pt-icon-symbol-triangle-down",
    WRENCH: "pt-icon-wrench" as "pt-icon-wrench",
    APPLICATION: "pt-icon-application" as "pt-icon-application",
    SEND_TO_GRAPH: "pt-icon-send-to-graph" as "pt-icon-send-to-graph",
    SEND_TO_MAP: "pt-icon-send-to-map" as "pt-icon-send-to-map",
    JOIN_TABLE: "pt-icon-join-table" as "pt-icon-join-table",
    DERIVE_COLUMN: "pt-icon-derive-column" as "pt-icon-derive-column",
    IMAGE_ROTATE_LEFT: "pt-icon-image-rotate-left" as "pt-icon-image-rotate-left",
    IMAGE_ROTATE_RIGHT: "pt-icon-image-rotate-right" as "pt-icon-image-rotate-right",
    KNOWN_VEHICLE: "pt-icon-known-vehicle" as "pt-icon-known-vehicle",
    UNKNOWN_VEHICLE: "pt-icon-unknown-vehicle" as "pt-icon-unknown-vehicle",
    SCATTER_PLOT: "pt-icon-scatter-plot" as "pt-icon-scatter-plot",
    OIL_FIELD: "pt-icon-oil-field" as "pt-icon-oil-field",
    RIG: "pt-icon-rig" as "pt-icon-rig",
    MAP_CREATE: "pt-icon-map-create" as "pt-icon-map-create",
    KEY_OPTION: "pt-icon-key-option" as "pt-icon-key-option",
    LIST_DETAIL_VIEW: "pt-icon-list-detail-view" as "pt-icon-list-detail-view",
    SWAP_VERTICAL: "pt-icon-swap-vertical" as "pt-icon-swap-vertical",
    SWAP_HORIZONTAL: "pt-icon-swap-horizontal" as "pt-icon-swap-horizontal",
    NUMBERED_LIST: "pt-icon-numbered-list" as "pt-icon-numbered-list",
    NEW_GRID_ITEM: "pt-icon-new-grid-item" as "pt-icon-new-grid-item",
    GIT_REPO: "pt-icon-git-repo" as "pt-icon-git-repo",
    GIT_NEW_BRANCH: "pt-icon-git-new-branch" as "pt-icon-git-new-branch",
    MANUALLY_ENTERED_DATA: "pt-icon-manually-entered-data" as "pt-icon-manually-entered-data",
    AIRPLANE: "pt-icon-airplane" as "pt-icon-airplane",
    MERGE_COLUMNS: "pt-icon-merge-columns" as "pt-icon-merge-columns",
    SPLIT_COLUMNS: "pt-icon-split-columns" as "pt-icon-split-columns",
    DASHBOARD: "pt-icon-dashboard" as "pt-icon-dashboard",
    PUBLISH_FUNCTION: "pt-icon-publish-function" as "pt-icon-publish-function",
    PATH: "pt-icon-path" as "pt-icon-path",
    MOON: "pt-icon-moon" as "pt-icon-moon",
    REMOVE_COLUMN: "pt-icon-remove-column" as "pt-icon-remove-column",
    NUMERICAL: "pt-icon-numerical" as "pt-icon-numerical",
    KEY_TAB: "pt-icon-key-tab" as "pt-icon-key-tab",
    REGRESSION_CHART: "pt-icon-regression-chart" as "pt-icon-regression-chart",
    TRANSLATE: "pt-icon-translate" as "pt-icon-translate",
    EYE_ON: "pt-icon-eye-on" as "pt-icon-eye-on",
    VERTICAL_BAR_CHART_ASC: "pt-icon-vertical-bar-chart-asc" as "pt-icon-vertical-bar-chart-asc",
    HORIZONTAL_BAR_CHART_ASC: "pt-icon-horizontal-bar-chart-asc" as "pt-icon-horizontal-bar-chart-asc",
    GROUPED_BAR_CHART: "pt-icon-grouped-bar-chart" as "pt-icon-grouped-bar-chart",
    FULL_STACKED_CHART: "pt-icon-full-stacked-chart" as "pt-icon-full-stacked-chart",
    ENDORSED: "pt-icon-endorsed" as "pt-icon-endorsed",
    FOLLOWER: "pt-icon-follower" as "pt-icon-follower",
    FOLLOWING: "pt-icon-following" as "pt-icon-following",
    MENU: "pt-icon-menu" as "pt-icon-menu",
    COLLAPSE_ALL: "pt-icon-collapse-all" as "pt-icon-collapse-all",
    EXPAND_ALL: "pt-icon-expand-all" as "pt-icon-expand-all",
    INTERSECTION: "pt-icon-intersection" as "pt-icon-intersection",
    BLOCKED_PERSON: "pt-icon-blocked-person" as "pt-icon-blocked-person",
    SLASH: "pt-icon-slash" as "pt-icon-slash",
    PERCENTAGE: "pt-icon-percentage" as "pt-icon-percentage",
    SATELLITE: "pt-icon-satellite" as "pt-icon-satellite",
    PARAGRAPH: "pt-icon-paragraph" as "pt-icon-paragraph",
    BANL_ACCOUNT: "pt-icon-banl-account" as "pt-icon-banl-account",
    CELL_TOWER: "pt-icon-cell-tower" as "pt-icon-cell-tower",
    ID_NUMBER: "pt-icon-id-number" as "pt-icon-id-number",
    IP_ADDRESS: "pt-icon-ip-address" as "pt-icon-ip-address",
    ERASER: "pt-icon-eraser" as "pt-icon-eraser",
    ISSUE: "pt-icon-issue" as "pt-icon-issue",
    ISSUE_NEW: "pt-icon-issue-new" as "pt-icon-issue-new",
    ISSUE_CLOSED: "pt-icon-issue-closed" as "pt-icon-issue-closed",
    PANEL_STATS: "pt-icon-panel-stats" as "pt-icon-panel-stats",
    PANEL_TABLE: "pt-icon-panel-table" as "pt-icon-panel-table",
    TICK_CIRCLE: "pt-icon-tick-circle" as "pt-icon-tick-circle",
    PRESCRIPTION: "pt-icon-prescription" as "pt-icon-prescription",
    NEW_PRESCRIPTION: "pt-icon-new-prescription" as "pt-icon-new-prescription",
};
